function popupConfirm(title = "", info1 = "", info2 = "", confirmText = "Yes", cancelText = "Cancel") {
  const popupWrapper = document.createElement("div");
  popupWrapper.innerHTML = `
        <div class="popup-overlay"></div>
        <div class="popup-confirm">
            <div class="popup-confirm-heading">${title ? `<div class="popup-confirm-title">${title}</div>` : ""}
                <button class="popup-close"></button>
            </div>
            <div class="popup-confirm-content">
                ${info1 ? `<span class="info-1">${info1}</span>` : ""}
                ${info2 ? `<span class="info-2">${info2}</span>` : ""}
                <div class="actions">
                    <div class="icon-arrow size-wide">
                        ${confirmText ? `<button class="confirm">${confirmText}</button>` : ""}
                    </div>
                    <div class="type-outline-blue icon-arrow size-wide">
                        ${cancelText ? `<button class="cancel">${cancelText}</button>` : ""}
                    </div>
                </div>
            </div>
        </div>`;
  document.body.appendChild(popupWrapper);

  return new Promise((resolve) => {
    const closePopup = () => {
      popupWrapper.remove();
      resolve(false);
    };

    popupWrapper.querySelector(".popup-close")?.addEventListener("click", closePopup);
    popupWrapper.querySelector(".cancel")?.addEventListener("click", closePopup);

    popupWrapper.querySelector(".confirm")?.addEventListener("click", () => {
      popupWrapper.remove();
      resolve(true);
    });
  });
}

export default popupConfirm;
